import Seo from '../components/Seo';
import { PAGES } from '../seo/meta.mjs';

const Privacy = () => {
  return (
    <div className="min-h-screen pt-20 bg-slate-950" data-testid="privacy-page">
      <Seo {...PAGES.privacy} />
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-24">
        <h1 className="font-heading font-light text-4xl md:text-6xl tracking-tighter text-white mb-12">
          Privacy <span className="text-ocean-500">Policy</span>
        </h1>
        <div className="space-y-8 text-slate-400 leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Information We Collect</h2>
            <p>
              When you use the contact form on this website, we collect the details you provide — your name,
              email address, phone number, company name and message — so that we can respond to your enquiry.
              We do not collect any other personal information.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">How We Use Your Information</h2>
            <p>
              Information submitted through the contact form is used solely to respond to your enquiry and
              discuss your project requirements. We do not sell, rent or share your personal information with
              third parties for marketing purposes.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Cookies and Analytics</h2>
            <p>
              This website does not require cookies for its core functionality. Third-party services used to
              render parts of the site (such as embedded maps) may set their own cookies subject to their
              respective privacy policies.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Data Retention</h2>
            <p>
              Enquiry details are retained only as long as needed to handle your request and any resulting
              business relationship. You may ask us to delete your details at any time.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Contact</h2>
            <p>
              For any questions about this policy or your data, contact us at{' '}
              <a href="mailto:info@ytekcontrols.com" className="text-ocean-500 hover:text-ocean-400">
                info@ytekcontrols.com
              </a>{' '}
              or +91 94120 75715.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
